// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Added missing vars that cause subscription 'more filters' display issues */
:root {
    --pc-legacy-filters-footer-height: 3.75rem;
    --pc-legacy-filters-header-height: 3.75rem;
}

/* LegacyCard section header padding is too small by default*/
.Polaris-LegacyCard__SectionHeader {
    padding-bottom: var(--p-space-400);
}
/* LegacyCard section padding is too small by default*/
.Polaris-LegacyCard__Section {
    padding-top: var(--p-space-400);
    padding-bottom: var(--p-space-400);
}

/* Slow down backdrop animation - issue when switching from one modal to another - blinking effect */
.Polaris-Backdrop {
    animation: none;
    opacity: 1;
}

/* Align bulk actions button to the left (instead of the far right) */
.Polaris-BulkActions__BulkActionsLayout {
    justify-content: flex-start;
}

@media (max-width: 48em) {
    /* On mobile choicelist legend/label is displayed too close to the list of choices */
    fieldset > legend + ul {
        padding-top: var(--p-space-200);
    }
}

@media (hover) and (pointer: fine), (min-width: 48em) {
    /* TextField input font size is too big by default. This value matches the font size used in Shopify admin */
    .Polaris-TextField__Input {
        font-size: var(--p-font-size-325);
        line-height: var(--p-font-line-height-500);
        caret-color: var(--p-color-text);
    }
    .Polaris-Select__Input, 
    .Polaris-Select__Content, 
    .Polaris-Select__Content div > span,
    .Polaris-Select {
        font-size: var(--p-font-size-325);
        line-height: var(--p-font-line-height-500);
    }
}

/* IndexFilters SortButton: a single-direction sort option (e.g. Relevance)
   leaves an empty, label-less second direction button. Hide the label-less one
   so only the real direction shows. The Icon child <span> always wraps an <svg>
   (never :empty), so only the empty label <span> matches. */
.Polaris-SortButton-DirectionButton:has(> span:empty) {
    display: none;
}

/* AdaptiveModal: the Polaris Modal footer wraps custom footer content in a
   content-sized Box, which left-aligns it. Widen that Box so our footer content
   (InlineStack align="end" action buttons, centered pagination, etc.) can
   position across the full footer width. */
.Polaris-Box:has(.AdaptiveModal-Footer) {
    width: 100%;
}

/* Intercom's vertical_padding boot setting is ignored on mobile, so we lift the
   launcher above Shopify's floating bottom nav bar in the mobile app only */
.shopify-mobile-app .intercom-lightweight-app-launcher,
.shopify-mobile-app #intercom-container .intercom-app > div:has(.intercom-launcher-frame) {
    bottom: calc(20px + var(--shopify-safe-area-inset-bottom, 0px)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/common/polaris-overwrites.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;IACI,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA,6DAA6D;AAC7D;IACI,kCAAkC;AACtC;AACA,sDAAsD;AACtD;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA,oGAAoG;AACpG;IACI,eAAe;IACf,UAAU;AACd;;AAEA,qEAAqE;AACrE;IACI,2BAA2B;AAC/B;;AAEA;IACI,oFAAoF;IACpF;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI,4GAA4G;IAC5G;QACI,iCAAiC;QACjC,0CAA0C;QAC1C,gCAAgC;IACpC;IACA;;;;QAII,iCAAiC;QACjC,0CAA0C;IAC9C;AACJ;;AAEA;;;4DAG4D;AAC5D;IACI,aAAa;AACjB;;AAEA;;;2CAG2C;AAC3C;IACI,WAAW;AACf;;AAEA;4EAC4E;AAC5E;;IAEI,0EAA0E;AAC9E","sourcesContent":["/* Added missing vars that cause subscription 'more filters' display issues */\n:root {\n    --pc-legacy-filters-footer-height: 3.75rem;\n    --pc-legacy-filters-header-height: 3.75rem;\n}\n\n/* LegacyCard section header padding is too small by default*/\n.Polaris-LegacyCard__SectionHeader {\n    padding-bottom: var(--p-space-400);\n}\n/* LegacyCard section padding is too small by default*/\n.Polaris-LegacyCard__Section {\n    padding-top: var(--p-space-400);\n    padding-bottom: var(--p-space-400);\n}\n\n/* Slow down backdrop animation - issue when switching from one modal to another - blinking effect */\n.Polaris-Backdrop {\n    animation: none;\n    opacity: 1;\n}\n\n/* Align bulk actions button to the left (instead of the far right) */\n.Polaris-BulkActions__BulkActionsLayout {\n    justify-content: flex-start;\n}\n\n@media (max-width: 48em) {\n    /* On mobile choicelist legend/label is displayed too close to the list of choices */\n    fieldset > legend + ul {\n        padding-top: var(--p-space-200);\n    }\n}\n\n@media (hover) and (pointer: fine), (min-width: 48em) {\n    /* TextField input font size is too big by default. This value matches the font size used in Shopify admin */\n    .Polaris-TextField__Input {\n        font-size: var(--p-font-size-325);\n        line-height: var(--p-font-line-height-500);\n        caret-color: var(--p-color-text);\n    }\n    .Polaris-Select__Input, \n    .Polaris-Select__Content, \n    .Polaris-Select__Content div > span,\n    .Polaris-Select {\n        font-size: var(--p-font-size-325);\n        line-height: var(--p-font-line-height-500);\n    }\n}\n\n/* IndexFilters SortButton: a single-direction sort option (e.g. Relevance)\n   leaves an empty, label-less second direction button. Hide the label-less one\n   so only the real direction shows. The Icon child <span> always wraps an <svg>\n   (never :empty), so only the empty label <span> matches. */\n.Polaris-SortButton-DirectionButton:has(> span:empty) {\n    display: none;\n}\n\n/* AdaptiveModal: the Polaris Modal footer wraps custom footer content in a\n   content-sized Box, which left-aligns it. Widen that Box so our footer content\n   (InlineStack align=\"end\" action buttons, centered pagination, etc.) can\n   position across the full footer width. */\n.Polaris-Box:has(.AdaptiveModal-Footer) {\n    width: 100%;\n}\n\n/* Intercom's vertical_padding boot setting is ignored on mobile, so we lift the\n   launcher above Shopify's floating bottom nav bar in the mobile app only */\n.shopify-mobile-app .intercom-lightweight-app-launcher,\n.shopify-mobile-app #intercom-container .intercom-app > div:has(.intercom-launcher-frame) {\n    bottom: calc(20px + var(--shopify-safe-area-inset-bottom, 0px)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
